const state = {
    sectionUpdate: false,
    sectionId: null,
  }
  const mutations = {
    sectionUpdateOpen: (state,bool)=>{
      state.sectionUpdate = bool;
    },
    sectionUpdateId: (state,id)=>{
        state.sectionId = id;
    },
  }
  
  const actions = {
    
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  
  